/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { useParams } from "react-router-dom";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
// material UI Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import { ImageAttribution } from "../components/ImageAttribution";
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import ObjectiveItem from "../components/cards/objectives/ObjectiveItem";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";

import SubComponentCard from "../components/SubComponent";

const Objectives = (props) => {
  const { data, dir, ins = [], course, comments = [] } = props;
  const routeParams = useParams();
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  const intro = data.core[0].title_tl === "N/A";
  let instructions = [];

  if (intro) {
    instructions = ins.filter((data) => data.title === "Course Introduction");
  } else {
    instructions = ins.filter((data) => data.title !== "Course Introduction");
  }

  return (
    <>
      <style>{`.wysiwyg p {margin: 0px; margin-bottom: 1.5rem;}`}</style>
      <div>
        <Instructions
          ins={instructions}
          course={course}
          dir={dir}
          tl={tl}
          componentCommentsCount={componentCommentsCount}
        />

        <Typography className="text-18 font-bold p-16 pb-0">
          Objectives:
        </Typography>

        {data.core.map((objective, index) => (
          <React.Fragment key={`tag-${objective.tag}-${index}`}>
            <ComponentCard
              title={objective.tag}
              id={objective.id}
              commentsCount={componentCommentsCount(objective.id)}
            >
              {/* <ComponentPreview>
                <ObjectiveItem objective={objective} index={index} diagram />
              </ComponentPreview> */}
              <ComponentStepLabel number="1" title="Image:" />
              <ImageAttribution
                key={`title-${objective.media.title_en}-${index}`}
                attribution={objective.media}
                tl={tl}
                dir={dir}
              />

              <SubComponentCard
                title={objective.tag + " content"}
                id={objective.tag + " content"}
                commentsCount={componentCommentsCount(
                  objective.tag + " content"
                )}
              >
                <Paper elevation={0} square className="p-16">
                  <Grid container spacing={1}>
                    {objective.title_tl !== "N/A" && (
                      <>
                        <Grid item xs={12} sm={4} lg={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Title (TL):
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8} lg={10}>
                          <Typography className={`${tl} m-0`} dir={dir}>
                            {objective.title_tl}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {objective.desc_tl !== "N/A" && (
                      <>
                        <Grid item xs={12} sm={4} lg={2}>
                          <Typography className="text-14 font-semibold mt-3">
                            Description (TL):
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8} lg={10}>
                          <Typography className={`${tl} m-0`} dir={dir}>
                            {objective.desc_tl}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={4} lg={2}>
                      <Typography className="text-14 font-semibold m-0">
                        Title (EN):
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8} lg={10}>
                      <Typography className="text-14 m-0">
                        {objective.title_en}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} lg={2}>
                      <Typography className="text-14 font-semibold mt-3">
                        Description (EN):
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8} lg={10}>
                      <Typography className="text-14 m-0">
                        {objective.desc_en}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </SubComponentCard>
            </ComponentCard>
          </React.Fragment>
        ))}
        {data.eMentor.length !== 0 && (
          <EMentor
            eMentor={data.eMentor}
            tl={tl}
            dir={dir}
            componentCommentsCount={componentCommentsCount}
          />
        )}
      </div>
    </>
  );
};

export default Objectives;
